import { cloneDeep } from "lodash";
import { allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allDevelopTypesOptions, allIncomeClassificators, allMeasureUnitsOptions, allMutuallyRedeemingLevelOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allSegmentationOptions, allStatusOptions, allStatusOptionsExtended } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Template } from "../../common/types/Template";
import { ReportBrFilterSettings } from "./settings/ReportBrFilterSettings";
import { ReportBrFilterOptions } from "./options/ReportBrFilterOptions";
import { Segmentation } from "../../common/types/roots/fields";
import { Draggable } from "../../common/types/Draggable";
import { Indicator } from "../../common/types/Indicator";

export const reportBrIndicators: Indicator[] = [
    { key: 'name', active: true },
    { key: 'utv_plan', active: true },
    { key: 'utoch_plan', active: true },
    { key: 'skor_plan', active: true },
    { key: 'months_group', active: true },
    { key: 'svod_plan', active: true },
    { key: 'plan_month', active: true },
    { key: 'registrob', active: true },
    { key: 'sumrg_group', active: true },
    { key: 'plan_remainder_group', active: true },
    { key: 'utilization_percent', active: true },
    { key: 'reason_plat', active: false },
    { key: 'reason_obaz', active: false },
    { key: 'supplier', active: true },
    { key: 'date_text', active: true },
]

export const reportBrExpensesClassificators: Classificator[] = [
    { key: 'gr',  active: true, selected: [] },
    { key: 'pgr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] },
]

export const reportBrSegmentationOptions: Draggable<Segmentation>[] = [
    ...allSegmentationOptions,
    { value: 'PROJECT', label: "Проект", labelKk: "Жоба", labelEn: "Project", active: true }
]

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportBrFilterSettings = {
    // Base:
    reportName: 'BR',
    reportType: 'REGULATED',
    classificationType: 'INCOMES_OR_EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'DAY',
    // Custom:
    date: '',
    segmentations: [],
    mutuallyRedeeming: 'WITHOUT',
    mutuallyRedeemingLevels: [],
    budgetTypes: [],
    region: '',
    statuses: [],
    expenses: [],
    measureUnit: 'MILLION',
    roundUpTo: null,
    planByMonths: false,
    hideZeroProjects: true,
    developType: null,
    indicators: cloneDeep(reportBrIndicators),
    rnnSuppliers: []
}

export const reportBrBaseTemplate: Template = {
    id: null,
    name: 'Отчет БР',
    excelName: null,
    description: null,
    category: '80',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportBrFilterOptions: ReportBrFilterOptions = {
    // Base:
    key: 'BR',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    regions: [], // Загружается с бэка
    segmentations: cloneDeep(reportBrSegmentationOptions),
    statuses: cloneDeep(allStatusOptionsExtended),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    developTypes: cloneDeep(allDevelopTypesOptions),
    expenses: cloneDeep(reportBrExpensesClassificators),
    suppliers: []
}
